import './migrateStorageKeys';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { OpsThemeProvider } from '@liftango/ui-tokens';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import { liftangoTheme } from './theme';
import { getRouterBasenameFromPublicUrl } from './utils/routerBasename';
import './i18n';
import I18nBridge from './components/I18nBridge';

// Preview deployments are served from a subpath via S3+CloudFront which does
// not automatically resolve subdirectory requests to index.html. Using
// HashRouter for preview builds keeps all navigation hash-based (#/route) so
// CloudFront never needs to handle sub-routes — it only ever serves index.html.
// Also match PUBLIC_URL containing /preview/: REACT_APP_USE_HASH_ROUTER may not embed
// reliably; PUBLIC_URL is always set for PR preview builds.
const publicUrlForPreview = (process.env.PUBLIC_URL ?? '').trim();
const runtimePathnameForPreview =
  typeof window !== 'undefined' ? window.location.pathname : '';
const isHashPreview =
  process.env.REACT_APP_USE_HASH_ROUTER === 'true' ||
  /\/preview\//.test(publicUrlForPreview) ||
  /\/preview\//.test(runtimePathnameForPreview);

const resolvedBrowserTitle = (process.env.REACT_APP_BROWSER_TITLE ?? '').trim();
const fallbackBrowserTitle =
  process.env.NODE_ENV === 'production'
    ? 'Atlas'
    : 'Local: Atlas';

if (typeof document !== 'undefined') {
  document.title = resolvedBrowserTitle || fallbackBrowserTitle;
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <OpsThemeProvider mode="light" density="comfortable">
      <ThemeProvider theme={liftangoTheme}>
        <CssBaseline />
        <I18nBridge />
        {isHashPreview ? (
          <HashRouter>
            <App />
          </HashRouter>
        ) : (
          <BrowserRouter basename={getRouterBasenameFromPublicUrl(process.env.PUBLIC_URL)}>
            <App />
          </BrowserRouter>
        )}
      </ThemeProvider>
    </OpsThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// (for example: reportWebVitals(console.log))
// to log results or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
